import React from "react";
import { Link } from "react-router-dom";
import footerBg from "../../assets/footer-bg.png";
import youTube from "../../assets/youTube.png";
import linkedin from "../../assets/linkedin.png";
import gitHub from "../../assets/github.png";
import twitter from "../../assets/twitter.png";
import facebook from "../../assets/facebook.png";
import leetCode from "../../assets/leetcode.png";

const Footer = () => {
  return (
    <>
      <section
        className="text-white"
        style={{
          background: `url(${footerBg})`,
          backgroundSize: "cover",
        }}
      >
        <footer className="footer p-10">
          <div className="grid grid-cols-3 gap-6">
            <a
              href="https://www.youtube.com/channel/UCOmHUn--16B90oW2L6FRR3A"
              target="_blank"
              rel="noreferrer"
              className="link link-hover"
            >
              <img src={youTube} alt="social-icon" />
            </a>
            <a
              href="https://www.linkedin.com/in/thakur-saad/"
              target="_blank"
              rel="noreferrer"
              className="link link-hover"
            >
              <img src={linkedin} alt="social-icon" />
            </a>
            <a
              href="https://github.com/ThakurSaad"
              target="_blank"
              rel="noreferrer"
              className="link link-hover"
            >
              <img
                className="bg-white rounded-full"
                src={gitHub}
                alt="social-icon"
              />
            </a>
            <a
              href="https://twitter.com/Thakur_Saad_B"
              target="_blank"
              rel="noreferrer"
              className="link link-hover"
            >
              <img src={twitter} alt="social-icon" />
            </a>
            <a
              href="https://www.facebook.com/Shadow.Monarch.Saad/"
              target="_blank"
              rel="noreferrer"
              className="link link-hover"
            >
              <img src={facebook} alt="social-icon" />
            </a>
            <a
              href="https://leetcode.com/thakursaad/"
              target="_blank"
              rel="noreferrer"
              className="link link-hover"
            >
              <img src={leetCode} alt="social-icon" />
            </a>
          </div>
          <div>
            <span className="footer-title">Services</span>
            <Link to="/" className="link link-hover">
              Branding
            </Link>
            <Link to="/" className="link link-hover">
              Design
            </Link>
            <Link to="/" className="link link-hover">
              Manufacturing
            </Link>
            <Link to="/" className="link link-hover">
              Modification
            </Link>
          </div>
          <div>
            <span className="footer-title">Company</span>
            <Link to="/" className="link link-hover">
              About us
            </Link>
            <Link to="/" className="link link-hover">
              Contact
            </Link>
            <Link to="/" className="link link-hover">
              Jobs
            </Link>
            <Link to="/" className="link link-hover">
              Press kit
            </Link>
          </div>
          <div>
            <span className="footer-title">Legal</span>
            <Link to="/" className="link link-hover">
              Terms of use
            </Link>
            <Link to="/" className="link link-hover">
              Privacy policy
            </Link>
            <Link to="/" className="link link-hover">
              Cookie policy
            </Link>
          </div>
        </footer>
        <footer className="footer px-10 py-4">
          <div className="items-center grid-flow-col">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
              className="fill-current"
            >
              <path d="M22.672 15.226l-2.432.811.841 2.515c.33 1.019-.209 2.127-1.23 2.456-1.15.325-2.148-.321-2.463-1.226l-.84-2.518-5.013 1.677.84 2.517c.391 1.203-.434 2.542-1.831 2.542-.88 0-1.601-.564-1.86-1.314l-.842-2.516-2.431.809c-1.135.328-2.145-.317-2.463-1.229-.329-1.018.211-2.127 1.231-2.456l2.432-.809-1.621-4.823-2.432.808c-1.355.384-2.558-.59-2.558-1.839 0-.817.509-1.582 1.327-1.846l2.433-.809-.842-2.515c-.33-1.02.211-2.129 1.232-2.458 1.02-.329 2.13.209 2.461 1.229l.842 2.515 5.011-1.677-.839-2.517c-.403-1.238.484-2.553 1.843-2.553.819 0 1.585.509 1.85 1.326l.841 2.517 2.431-.81c1.02-.33 2.131.211 2.461 1.229.332 1.018-.21 2.126-1.23 2.456l-2.433.809 1.622 4.823 2.433-.809c1.242-.401 2.557.484 2.557 1.838 0 .819-.51 1.583-1.328 1.847m-8.992-6.428l-5.01 1.675 1.619 4.828 5.011-1.674-1.62-4.829z"></path>
            </svg>
            <p>
              AlPHA STEELWORK LTD. <br />
              Providing reliable tech since 1992
            </p>
          </div>
        </footer>
      </section>
    </>
  );
};

export default Footer;
